import React, { Fragment } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import BuyTabMenu from "./BuyTabMenu";
import DistributeTabMenu from "./DistributeTabMenu";
import AdminDistributeTabMenu from "./AdminDistributeTabMenu";
import ProductTabMenu from "./ProductTabMenu";
import StoreTabMenu from "./StoreTabMenu";

const Holder = styled(Row)`
  width: 100%;
  padding: 1.5rem 0 1.1rem 0;

  @media (max-width: 900px) {
    padding-bottom: 2.5rem;
  }
`;

const TabMenues = ({
  onCollapse,
  onCreateSuccess,
  currentTab,
  currentData,
  parentType,
  filterQuery,
  productsFilterQuery,
}) => {
  return (
    <Holder>
      {currentTab === "buy" && (
        <BuyTabMenu
          tabData={currentData}
          onCollapse={onCollapse}
          onCreateSuccess={onCreateSuccess}
          filterQuery={filterQuery}
        />
      )}
      {currentTab === "distribute" && (
        <Fragment>
          {parentType === 'admin' ? (
            <AdminDistributeTabMenu
              tabData={currentData}
              onCollapse={onCollapse}
              onCreateSuccess={onCreateSuccess}
              filterQuery={filterQuery}
            />
          ) : (
            <DistributeTabMenu
              tabData={currentData}
              onCollapse={onCollapse}
              onCreateSuccess={onCreateSuccess}
              filterQuery={filterQuery}
            />
          )}
        </Fragment>
      )}
      {currentTab === "product" && (
        <ProductTabMenu
          tabData={currentData}
          onCreateSuccess={onCreateSuccess}
          filterQuery={filterQuery}
          productsFilterQuery={productsFilterQuery}
        />
      )}
      {currentTab === "store" && (
        <StoreTabMenu
          tabData={currentData}
          parentType={parentType}
        />
      )}
    </Holder>
  );
};

export default TabMenues;
